
<!-------------------Banner starts------------------------------>
<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center h-100 w-100">

                <img src="../../../assets/images/banners/curorcbannarimage.png"
                    alt="Banner-mit" class=" img img-responsive w-100 h-100 d-none d-md-block">

                <!-- Md -->
                <img src="../../../assets/images/banners/curorcmobilebannar.png"
                    class="img img-responsive d-block d-md-none" width="100%" alt="curor mobile banner" />
                <!-- Md -->

                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-md-4 col-sm-12">
                            <div class="banner-section">
                                <div class="align-items-center global_title global_banner_title  title_banner_content futek-title"  role="heading" aria-level="1" >
                                    <span>Transform into a Data-Driven Organization</span>
                                </div>
                                <div class="global_sub_title global_banner_subtitle mt-3"  role="heading" aria-level="1" >
                                    <span> Learn how we built a simple, lean and intuitive all-in-one management
                                        software.</span>
                                </div>

                                <div class="col pt-lg-3 pt-3 mt-lg-3">
                            <a href="contact" class="global_button   text-left col text-white white_button" aria-label="View Contact Page">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png" alt="arrow white" /></div>
                            EXPLORE  </a>
                            </div>



                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class=" banner-subsection col">
         <h5>Trusted by Global Technology companies</h5>
         </div> -->
    </div>
</div>
<!-------------------Banner ends------------------------------>


<!--====== Caro-Rc MAin section Start ======-->
<div class="vision-overview section-space--pt_100">
    <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-5">
            <div class="heading global_section_header futeck_mediaquares">CuroRC: Empowering rapid-paced Studios with Technology Intelligence</div>
        </div>
        <div class="col-lg-5">
            <div class="portfolio-details-content">
                <div class="text ">
                    <div class="global_section_content futeck_mediaquares">CuroRC is all in one Class Management Software Solution for Studios
                    and Associations offering multi- faceted platform. The software supports multiple business owners benefitting to operate 
                    their business from anywhere and any device, making it faster, convenient, more secure, and less expensive while removing 
                    manual processes at the same time.
                    </div>
                    <br>
                    <div class="global_section_content futeck_mediaquares">The system provides personalized, comprehensive reporting and advanced 
                    business intelligence tools that facilitate a clear overview or detailed exploration of specific aspects. The development of 
                    this SaaS solution was stimulated from the needs and challenges faced by a martial arts studio. Successively, the product was 
                    designed to meet the need of customers in this industry and can be customized based on further requirements.
                    </div>
                </div>
        </div>
    </div>
    <div class="col-lg-1"></div>
</div>
<!--====== Caro-Rc MAin section End ======-->


<!--====== Caro-Rc Helping build Start ======-->
<div class="carorc_helpingsection">
    <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-11">
            <div class="global_section_header futeck_mediaquares">Helping build a simple, lean and intuitive all-in-one
                management software.</div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-10">
            <div class="global_section_content pt-5 futeck_mediaquares">
            A technological overhaul revolutionized a martial arts studio's operations by integrating MySQL Database, AWS Cloud, 
            AngularJS, and PHP Framework with Symfony. The resulting software covered registration, management, and studio intelligence, 
            empowering the studio with features like member profiles, cloud-based class scheduling, real-time communication, and secure 
            payment processing.
            </div>
            <div class="global_section_content pt-5 futeck_mediaquares">
            During this transformation, Maganti IT played a crucial role in establishing a robust technology background for a seamless 
            user experience, delivering expertise in technology resilience and web design. The standardization and automation of IT 
            support services significantly reduced infrastructure-provisioning time, allowing swift adaptation to changing demands.
            </div>
        </div>
        <div class="col-lg-1"></div>
    </div>
</div>
<!--====== Caro-Rc Helping build End ======-->


<!--====== Caro-Rc offers  Start ======-->
<div class="feature-icon-wrapper section-space-1--ptb_100">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title-wrap text-center section-space--mb_40">
                    <div class="section-sub-title mb-20 global_section_header carporate_blodcontent" role="heading" aria-level="1" >CuroRC offers the
                        following features </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="feature-list__two">
                    <div class="row">
                        <div class="col-lg-4 col-md-6 wow move-up">
                            <div class="ht-box-icon style-02 single-svg-icon-box">
                                <div class="icon-box-wrap">
                                    <div class="icon">
                                        <img src="../../../assets/images/curorcimages/customer.png"
                                            alt="customer curor" />
                                    </div>
                                    <div class="content">
                                        <div class="software-heading text-black carporate_blodcontent">
                                            Customer Management </div>
                                        <div class="software-text mt-3 global_section_content">
                                            Helping provide a complete picture of all customer interactions, keeping
                                            track of your sales,
                                            organizing and facilitating collaboration between various teams.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 wow move-up">
                            <div class="ht-box-icon style-02 single-svg-icon-box">
                                <div class="icon-box-wrap">
                                    <div class="icon">
                                        <img src="../../../assets/images/curorcimages/selfservice.png"
                                            alt="self service" />
                                    </div>
                                    <div class="content">
                                        <div
                                            class="software-heading  carporate_blodcontent text-black">
                                            Self Service Registration </div>
                                        <div class="software-text mt-3 global_section_content"> Self-service customer
                                            support software offers knowledge databases and self-service portals
                                            so businesses can automatically help users 24/7.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 wow move-up">
                            <div class="ht-box-icon style-02 single-svg-icon-box">
                                <div class="icon-box-wrap">
                                    <div class="icon">
                                        <img src="../../../assets/images/curorcimages/multiplestudio.png"
                                            alt="multiple studio" />
                                    </div>
                                    <div class="content">
                                        <div class="software-heading  text-black carporate_blodcontent">
                                            Multiple Studio Management </div>
                                        <div class="software-text mt-3 global_section_content">Helping manage the entire
                                            studio efficiency in one
                                            place- improving your studio's efficiency and sales.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 wow move-up">
                            <div class="ht-box-icon style-02 single-svg-icon-box">
                                <div class="icon-box-wrap">
                                    <div class="icon">
                                        <img src="../../../assets/images/curorcimages/employee.png"
                                            alt="employee" class="curor employee" />
                                    </div>
                                    <div class="content">
                                        <div class="software-heading  text-black carporate_blodcontent">
                                            Employee and Instructor Management </div>
                                        <div class="software-text mt-3">We built a software designed to help activity
                                            centers manage administrative operations such as attendance tracking,
                                            class scheduling, billing, skill assessment and KPI's.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 wow move-up">
                            <div class="ht-box-icon style-02 single-svg-icon-box">
                                <div class="icon-box-wrap">
                                    <div class="icon">
                                        <img src="../../../assets/images/curorcimages/pricingtag.png"
                                            alt="pirce tag" />
                                    </div>
                                    <div class="content">
                                        <div
                                            class="software-heading  text-black carporate_blodcontent ">
                                            Pricing Plans & Subscription Management </div>
                                        <div class="software-text mt-3">Providing a complete solution to manage the
                                            subscription lifecycle –
                                            from billing and metrics to payments & customization.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 wow move-up">
                            <div class="ht-box-icon style-02 single-svg-icon-box">
                                <div class="icon-box-wrap">
                                    <div class="icon">
                                        <img src="../../../assets/images/curorcimages/payment.png"
                                            alt="curor payment" />
                                    </div>
                                    <div class="content">
                                        <div class="software-heading  text-black carporate_blodcontent">
                                            Payment system (PCI compliance) </div>
                                        <div class="software-text mt-3">Automate your business's payment process, send
                                            payment reminders, provide
                                            multiple payment options, and follow up on failed payments.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 wow move-up">
                            <div class="ht-box-icon style-02 single-svg-icon-box">
                                <div class="icon-box-wrap">
                                    <div class="icon">
                                        <img src="../../../assets/images/curorcimages/business.png"
                                            alt="curor images" />
                                    </div>
                                    <div class="content">
                                        <div class="software-heading  text-black carporate_blodcontent">
                                            Business Analytic Reports </div>
                                        <div class="software-text mt-3">Handling multiple aspects of machine generated
                                            data, such as,
                                            searching, monitoring, and analyzing.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 wow move-up">
                            <div class="ht-box-icon style-02 single-svg-icon-box">
                                <div class="icon-box-wrap">
                                    <div class="icon">
                                        <img src="../../../assets/images/curorcimages/textmessage.png"
                                            alt="curor textmessange" />
                                    </div>
                                    <div class="content">
                                        <div class="software-heading  text-black carporate_blodcontent">
                                            Text messaging integration </div>
                                        <div class="software-text mt-3">Send and receive text messages across channels.
                                            Support commerce,
                                            customers, notifications, and follow ups.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 wow move-up">
                            <div class="ht-box-icon style-02 single-svg-icon-box">
                                <div class="icon-box-wrap">
                                    <div class="icon">
                                        <img src="../../../assets/images/curorcimages/memberportal.png"
                                            alt="curor memberportal" />
                                    </div>
                                    <div class="content">
                                        <div class="software-heading  text-black carporate_blodcontent">
                                            Member portal with Online Shopping cart and class booking</div>
                                        <div class="software-text mt-3">Adding in and registering patients, book
                                            classes,
                                            and shopping online with one intuitive platform.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--====== Caro-Rc offers End ======-->
